import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios'; // Import axios

axios.defaults.baseURL = 'https://apigw.thespacesafe.com/admin/api/v1'; // Set your base URL here

const OTPVerification: React.FC = () => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const navigate = useNavigate();
  const { usernameFor2FA, setIsAuthenticated, setIs2FAEnabled, setAuthToken , loginComplete} = useAuth();

  
  const handleVerifyOTP = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsVerifying(true);

    if (!usernameFor2FA) {
      setError('No username found for OTP verification.');
      setIsVerifying(false);
      return;
    }

    try {

      // console.log("Calling OTP Verification Service",{ email: usernameFor2FA, token : otp });

      const response = await axios.post('/account/login/sso/getToken', { email: usernameFor2FA, token : otp });

      const data = response.data;

      // admin-portal-backend getToken returns BaseResponse<AuthenticationResult>:
      // { data: { accessToken: "<JWT with SessionId/sub/email claims>" } }.
      // That JWT carries the Redis session id (SessionId claim) the BFF needs —
      // capture the REAL token here so the request interceptor can derive the
      // XSessionId/XUserId/XUserEmail headers. (Previously read data?.token, which
      // doesn't exist, so it always stored the literal 'TokenPlaceholder'.)
      const accessToken = data?.data?.accessToken;

      if (response.status === 200 && accessToken) {
        // OTP verification successful
        loginComplete(accessToken);
        setIs2FAEnabled(false);
        console.log('OTP verification successful');
        navigate('/home');
      } else {
        // OTP verification failed (or no token returned)
        setError(data?.message || 'Invalid OTP');
      }
    } catch (error: any) {
      setError(error.response?.data?.message || 'Failed to connect to the server.');
      console.error('OTP verification error:', error);
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card p-4">
            <h2 className="text-center mb-4">Verify OTP</h2>
            {usernameFor2FA && (
              <p className="text-center mb-3">
                Enter the OTP sent to your device for user: {usernameFor2FA}
              </p>
            )}
            {!usernameFor2FA && (
              <p className="text-center mb-3 text-danger">
                Something went wrong, please log in again.
              </p>
            )}
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleVerifyOTP}>
              <div className="mb-3">
                <label htmlFor="otp" className="form-label">
                  Verification Code:
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="otp"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  disabled={isVerifying}
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={isVerifying}
              >
                {isVerifying ? 'Verifying...' : 'Verify OTP'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;